// Listed first: every tenant today is Polish.
export const PREFERRED_TIME_ZONE = 'Europe/Warsaw';

type SupportedValuesOf = (key: 'timeZone') => string[];

/** Every IANA zone the browser knows, the preferred one first and the saved one kept. */
export const timeZoneOptions = (current: string | undefined) => {
  // Not in the ES2020 lib typings, and missing from older engines.
  const supportedValuesOf = (Intl as { supportedValuesOf?: SupportedValuesOf }).supportedValuesOf;
  const zones = supportedValuesOf ? supportedValuesOf('timeZone') : [];
  return [...new Set([PREFERRED_TIME_ZONE, ...(current ? [current] : []), ...zones])].map(
    (zone) => ({ value: zone, label: zone })
  );
};
